import { render, staticRenderFns } from "./TabModeratorEventParticipant.vue?vue&type=template&id=ec12fa50&"
import script from "./TabModeratorEventParticipant.vue?vue&type=script&lang=js&"
export * from "./TabModeratorEventParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports